import { render, staticRenderFns } from "./ModalShare.vue?vue&type=template&id=64d41b45&scoped=true"
import script from "./ModalShare.vue?vue&type=script&lang=ts"
export * from "./ModalShare.vue?vue&type=script&lang=ts"
import style0 from "./ModalShare.vue?vue&type=style&index=0&id=64d41b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d41b45",
  null
  
)

export default component.exports